"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventListenerManager = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const TableauError_1 = require("./TableauError");
/**
 * Class designed to register and unregister handlers from a user. Only those events
 * which are added via AddNewEventType will be supported by this instance
 */
class EventListenerManager {
    constructor() {
        this._eventListenerManagers = {};
    }
    addEventListener(eventType, handler) {
        if (!this._eventListenerManagers.hasOwnProperty(eventType)) {
            throw new TableauError_1.TableauError(api_external_contract_js_1.ErrorCodes.UnsupportedEventName, `Cannot add event, unsupported event type: ${eventType}`);
        }
        return this._eventListenerManagers[eventType].addEventListener(handler);
    }
    removeEventListener(eventType, handler) {
        if (!this._eventListenerManagers.hasOwnProperty(eventType)) {
            throw new TableauError_1.TableauError(api_external_contract_js_1.ErrorCodes.UnsupportedEventName, `Cannot remove event, unsupported event type: ${eventType}`);
        }
        return this._eventListenerManagers[eventType].removeEventListener(handler);
    }
    addNewEventType(eventManager) {
        this._eventListenerManagers[eventManager.eventType] = eventManager;
    }
}
exports.EventListenerManager = EventListenerManager;
//# sourceMappingURL=EventListenerManager.js.map